<template>
  <div class="w-full h-full grid md:grid-cols-7">
    <LoginComponent class="relative col-span-4" />
    <WelcomeComponent class="relative hidden md:flex col-span-3" />
  </div>
</template>

<script>
import LoginComponent from '../components/appComponent/LoginComponent.vue'
import WelcomeComponent from '../components/appComponent/WelcomeComponent.vue'

export default {
  components: {
    WelcomeComponent,
    LoginComponent,
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>
